import img_01 from "../assets/grid_carousel_01.webp";
import img_02 from "../assets/grid_carousel_37.webp";
import img_03 from "../assets/gallery____1.webp";
import img_04 from "../assets/gal________3.webp";
import img_05 from "../assets/grid_carousel_15.webp";
import img_06 from "../assets/grid_carousel_33.webp";
import img_07 from "../assets/grid_carousel_21.webp";
import img_08 from "../assets/grid_carousel_39.webp";
import img_09 from "../assets/gallery carousel_40.webp";
import img_10 from "../assets/grid_carousel_09.webp";
import img_11 from "../assets/gallery carousel_42.webp";
import img_12 from "../assets/gal_______2.webp";
import img_13 from "../assets/gal___________5.webp";
import img_14 from "../assets/grid_carousel_04.webp";
import img_15 from "../assets/grid_carousel_16.webp";

const WeddingGallery = () => {
  const images = [
    { src: img_01, alt: "Wedding portrait" },
    { src: img_02, alt: "Bridal portrait" },
    { src: img_03, alt: "Fashion portrait" },
    { src: img_04, alt: "Black and white portrait" },
    { src: img_05, alt: "Palace portrait" },
    { src: img_06, alt: "Artistic portrait" },
    { src: img_07, alt: "Bride close-up" },
    { src: img_08, alt: "Couple portrait" },
    { src: img_09, alt: "Wedding editorial" },
    { src: img_10, alt: "Outdoor portrait" },
    { src: img_11, alt: "Traditional portrait" },
    { src: img_12, alt: "Traditional portrait" },
    { src: img_13, alt: "Traditional portrait" },
    { src: img_14, alt: "Traditional portrait" },
    { src: img_15, alt: "Traditional portrait" },
  ];

  const columnSizes = [
    ["h-[600px]", "h-[400px]", "h-[600px]"],
    ["h-[400px]", "h-[600px]", "h-[550px]"],
    ["h-[600px]", "h-[500px]", "h-[500px]"],
    ["h-[500px]", "h-[400px]", "h-[550px]"],
    ["h-[400px]", "h-[600px]", "h-[600px]"],
  ];

  const columns = [[], [], [], [], []];

  images.forEach((image, index) => {
    const columnIndex = index % 5;
    const rowIndex = Math.floor(index / 5);

    columns[columnIndex].push({
      ...image,
      size: columnSizes[columnIndex][
        rowIndex % columnSizes[columnIndex].length
      ],
      id: index,
    });
  });

  return (
    <section className="w-full overflow-hidden">
      <div className="grid grid-cols-5 gap-[1px]">
        {columns.map((column, columnIndex) => (
          <div key={columnIndex} className="flex min-w-0 flex-col gap-[1px]">
            {column.map((image) => (
              <div
                key={image.id}
                className={`group relative w-full ${image.size} overflow-hidden`}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105"
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default WeddingGallery;
